export const GET_CHAT_REQUEST = "GET_CHAT_REQUEST";
export const GET_CHAT_REQUEST_SUCCESS = "GET_CHAT_REQUEST_SUCCESS";
export const GET_CHAT_REQUEST_FALUIRE = "GET_CHAT_REQUEST_FALUIRE";
